angular.module('invoice')
    .component('invoiceManagerialCategoryList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/managerial-category/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, Principal, InvoiceManagerialCategoryService, InvoiceService) {
            this.reset = () => this.filters = {}
            this.InvoiceService = InvoiceService
            this.InvoiceManagerialCategoryService = InvoiceManagerialCategoryService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_INVOICE_SETTINGS_WRITE'])
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-managerial-category-batch/export?" + $httpParamSerializer(paramsAll)
            }
            $scope.$on('invoice-managerial-category.updated', () => $state.reload())
        }
    })
